import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled, { css } from 'styled-components';
import { getTextColor } from "../../theme/color-tokens";
import { baseFontFamily } from "../../theme/fonts";
export var baseTextStyles = css(["margin:0;-webkit-text-size-adjust:none;font-family:", ";"], baseFontFamily);
export var textStyles = {
  header: css(["", ";font-size:16px;font-weight:500;line-height:20px;"], baseTextStyles),
  primary: css(["", ";font-size:14px;font-weight:400;line-height:20px;"], baseTextStyles),
  secondary: css(["", ";font-size:12px;font-weight:400;line-height:16px;"], baseTextStyles),
  body: css(["", ";font-size:13px;font-weight:400;line-height:20px;"], baseTextStyles),
  link: css(["", ";font-size:13px;font-weight:500;line-height:20px;"], baseTextStyles),
  caption: css(["", ";font-size:10px;font-weight:500;line-height:16px;"], baseTextStyles)
};
export var Text = React.forwardRef(function (_ref, ref) {
  var _ref$display = _ref.display,
      display = _ref$display === void 0 ? 'block' : _ref$display,
      truncate = _ref.truncate,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'body' : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      other = _objectWithoutProperties(_ref, ["display", "truncate", "color", "variant"]);

  return /*#__PURE__*/React.createElement(StyledText, _extends({
    ref: ref,
    $color: color,
    $truncate: truncate,
    $variant: variant,
    $display: display
  }, other));
});
export var truncateStyles = css(["overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:block;"]);
var StyledText = styled.span.withConfig({
  displayName: "Text__StyledText",
  componentId: "vapor__sc-3ie3rc-0"
})(["color:", ";display:", ";", " ", ""], function (p) {
  var _getTextColor;

  return (_getTextColor = getTextColor(p.$color)) !== null && _getTextColor !== void 0 ? _getTextColor : p.$color;
}, function (p) {
  return p.$display;
}, function (p) {
  return textStyles[p.$variant];
}, function (p) {
  if (p.$truncate === true) {
    return truncateStyles;
  }

  if (typeof p.$truncate === 'number') {
    return lineClamp(p.$truncate);
  }

  return null;
});

var lineClamp = function lineClamp(lines) {
  return css(["display:-webkit-box;-webkit-line-clamp:", ";-webkit-box-orient:vertical;overflow:hidden;"], lines);
};